module.exports = __webpack_public_path__ + "img/j7.bcf45853.png";